export class LoadDistributors {
  static readonly type = '[Distributor] Load Distributors';
}

export class SetSelectedDistributor {
  static readonly type = '[Distributor] Set Selected Distributor';
  constructor(public distributor: string) {}
}

export class ClearDistributorData {
  static readonly type = '[Distributor] Clear Data';
} 